
/**
 * UI类
 */
export namespace UIKind {
    

    /** ui层标识 */
    export enum UILayerTag {
        /** 矿地 */
        KD = 'kd',
        /** 驿站 */
        XH = 'xh',
        /** 飞鸽 */
        WE_CHAT = 'weChat',
        /** 飞鸽 */
        WE_CHAT_FRAME = 'WE_CHAT_FRAME',
        /** 百乐门 */
        BLM = 'xmb',
        /** 招工 */
        JOB = 'cd',
        /** 集市 */
        BAZZAR = 'bazzar',
        /** 比武招亲 */
        MATCH_MIAI = 'matchMiai',
        /** 衙门 */
        GOVERNMENT = 'hzs',
        /** 府邸 */
        MansionLayer = 'MansionLayer',
        /** 典当 */
        PAWN = 'js',
        /** 考场 */
        EXAM = 'exam',
        /** 账单 */
        BILL = 'bill',
        /** 用户设置 */
        USER_SETTING = 'user_setting',
        /** 考试 */
        EXAM_LAYER = 'exam_layer',
        /** 考试 */
        EXAM_SUCCESS_LAYER = 'ExamSuccessLayer',
        OREPAYMENT_LAYER = 'OREPAYMENT_LAYER',
        OPENING_MAIL_LAYER = 'OpeningMailLayer',
        /** 事件 */
        EnterLayerEventShow = 'EnterLayerEventShow',
        /** 开始事件 */
        START_PAGE = 'START_PAGE',
        /** 贷款成功 */
        LOANSUCCESSPAGE = 'LOANSUCCESSPAGE',
        /** 贷款界面 */
        LOAN_PAGE = 'LOAN_PAGE',
        /**  */
        GameEndEventLayer = 'GameEndEventLayer',
        /** 招募 */
        MilitaryRecruitOfficerLayer = 'MilitaryRecruitOfficerLayer',
        /** 地图 */
        MilitaryMapLayer = 'MilitaryMapLayer',
        /** 皇宫 */
        PalaceLayer = 'PalaceLayer',
        /** 超级权限 */
        SuperPowerCompoundLayer = 'SuperPowerCompoundLayer',
        /** 崆峒镜 */
        ThruTimeAccessLayer = 'ThruTimeAccessLayer',
        /** 超级权限 */
        SuperPowerSelectLayer = 'SuperPowerSelectLayer',
        /** 百乐门楼上 */
        ShopUpstairsLayer = 'ShopUpstairsLayer',
        /** 河道 */
        WaterCourse = "WaterCourse",
        /** 任务 */
        TaskLayer = "TaskLayer",
        /** 考古 */
        KaoGuLayer = "KaoGuLayer",
        /** 油田 */
        OilFieldLayer = "OilFieldLayer",
        /** 补偿 */
        CompensateAwardLayer1 = "CompensateAwardLayer1",
        /** 跳过剧情 */
        SkipPlotSelectLayer = "SkipPlotSelectLayer",
        /** 商船 */
        ShipListLayer = "ShipListLayer",
    }
}